export default "__VITE_ASSET__PsNRgFjX__"